import React from 'react';
import clsx from 'clsx';
import { hasErrorCode } from '@/utils/errors';
import errorCodes from '@/constants/errors';
import NotAuthorised from '@/components/errors/NotAuthorised';
import {
  fetchCollections,
  showSaveCollection,
  toggleCollectionSelected,
  toggleCollectionsPresentation,
} from '../actions';

const CollectionsPanelContainer = ({
  readErrors,
  canRead,
  className,
  children,
}) => {
  if (!canRead || hasErrorCode(readErrors, errorCodes.forbidden)) {
    return <NotAuthorised />;
  }

  return (
    <div className={clsx('aridhia-collections-panel-container', className)}>
      { children }
    </div>
  );
};

export const mapStateToProps = ({
  auth: { role: { permissions } },
  collections: { collections, newCollectionCode },
}, { category, displayAs }) => {
  const item = collections[category];

  return {
    allowMultiSelect: permissions.collections.destroy,
    canCreate: permissions.collections.create,
    canRead: permissions.datasets.read,
    currentPage: item.currentPage,
    collections: item.results,
    display: displayAs || item.display,
    filterTerm: item.filter,
    newCollectionCode,
    pageCount: item.totalPages,
    pageSize: item.pageSize,
    readErrors: item.readErrors,
    readStatus: item.readStatus,
    total: item.count,
  };
};

export const mapDispatchToProps = {
  fetchData: fetchCollections,
  newCollection: showSaveCollection,
  onCheckBoxClick: toggleCollectionSelected,
  togglePresentation: toggleCollectionsPresentation,
};

export default CollectionsPanelContainer;
